
<h5 mat-dialog-title>{{ paragraphUtil.getTranslation('confirmation_message') }}</h5>  
<div class="buttons">
    <button mat-flat-button (click)="onCancel()" color="primary">
        {{ "Cancel" | translate }}
    </button>
    <button mat-flat-button (click)="onConfirm()" color="primary">
        {{ "Continue" | translate }}
    </button>
</div>